import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { currentSeason } from '@/utils';

// Same per-pageload season switch as the leaderboard URL and header
// (see office#884); the static index.html title stays season-neutral.
document.title = `Spark Points | Season ${currentSeason()}`;

// @ts-ignore
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
